import { supabase } from '../supabaseClient';

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

const requireUploadUrl = (data) => {
  if (!data?.uploadUrl || !data?.publicUrl) {
    throw new Error('Cloudflare upload URL was not returned.');
  }
  return data;
};

const createUploadUrl = async ({ bucket, folder, filename, contentType }) => {
  if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
    throw new Error('Supabase upload configuration is missing.');
  }

  const { data: sessionData } = await supabase.auth.getSession();
  const token = sessionData?.session?.access_token || SUPABASE_ANON_KEY;
  const response = await fetch(`${SUPABASE_URL}/functions/v1/upload-image`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ bucket, folder, filename, contentType }),
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(`upload-image Edge Function failed (${response.status}): ${payload.error || response.statusText || 'request failed'}`);
  }
  return requireUploadUrl(payload);
};

export const uploadToR2 = async ({ bucket, folder, filename, contentType, body }) => {
  const upload = await createUploadUrl({ bucket, folder, filename, contentType });
  const response = await fetch(upload.uploadUrl, {
    method: 'PUT',
    headers: { 'Content-Type': contentType },
    body,
  });
  if (!response.ok) {
    throw new Error(`Cloudflare upload failed (${response.status}).`);
  }
  return upload.publicUrl;
};

export const uploadFileToR2 = async ({ bucket, folder, filename, file }) =>
  uploadToR2({
    bucket,
    folder,
    filename,
    contentType: file.type || 'application/octet-stream',
    body: file,
  });
